import { z } from 'zod';
import { requiredString } from '../helpers';
export const Campaign_Monitor_Add_Subscriber_1_ConfigValidator = z.object({
    campaignMonitorConnection: requiredString('Campaign Monitor connection is required'),
    listId: requiredString('List ID is required'),
    email: requiredString('Email is required'),
    name: z.string().optional(),
    mobileNumber: z.string().optional(),
    resubscribe: z.boolean().optional(),
    restartSubscriptionBasedAutoresponders: z.boolean().optional()
});
//# sourceMappingURL=campaign-monitor-add-subscriber-1.js.map